// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_4ad","cls2":"Comments-cls2_c_0 Comments-cls1_4ad"};